// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bih_tr","LeftMenu__link":"ir_b bih_vt bih_a bih_rc","LeftMenu__link__icon":"ir_c"};